import {TKey} from '@/translations/i18n'
import {
    SiarBulkExportType,
    SiarExportStatus,
    SiarExportsColumn,
    SiarPreviewItemProgressStatus
} from '@/features/projects/siar-bulk-export/types'

export const siarExportTypeToLabel = {
    open_project: 'projects:bulk_siar_export_type_open',
    close_project: 'projects:bulk_siar_export_type_close'
} as const satisfies Record<SiarBulkExportType, TKey>

export const siarExportTypeToNoEligibleProjectsLabel = {
    open_project: 'projects:bulk_siar_export_no_eligible_projects_open',
    close_project: 'projects:bulk_siar_export_no_eligible_projects_close'
} as const satisfies Record<SiarBulkExportType, TKey>

export const siarExportStatusToLabel = {
    pending: 'projects:bulk_siar_export_status_pending',
    partially_transmitted: 'projects:bulk_siar_export_status_partially_transmitted',
    transmitted: 'projects:bulk_siar_export_status_transmitted'
} as const satisfies Record<SiarExportStatus, TKey>

export const siarExportStatusToBadgeVariant = {
    pending: 'orange',
    partially_transmitted: 'danger',
    transmitted: 'success'
} as const satisfies Record<SiarExportStatus, 'danger' | 'orange' | 'success'>

export const siarPreviewProgressStatusToLabel = {
    to_export: 'projects:status_to_export',
    to_transmit: 'projects:status_to_transmit'
} as const satisfies Record<SiarPreviewItemProgressStatus, TKey>

export const siarPreviewProgressStatusToBadgeVariant = {
    to_export: 'orange',
    to_transmit: 'primary'
} as const satisfies Record<SiarPreviewItemProgressStatus, 'neutral' | 'orange' | 'primary' | 'success'>

export const siarExportColumnToLabel = {
    exportType: 'projects:bulk_siar_export_column_type',
    period: 'projects:bulk_siar_export_column_period',
    createdAtAndAuthor: 'projects:bulk_siar_export_column_created_at',
    status: 'projects:bulk_siar_export_column_status',
    transmittedAt: 'projects:bulk_siar_export_column_transmitted_at',
    name: 'projects:bulk_siar_export_column_name',
    moreActions: 'commons:actions'
} as const satisfies Record<SiarExportsColumn, TKey>
